import type { NuxtApp } from '#app/nuxt';
import { clientInit } from '#imports';

export default defineNuxtPlugin(async (nuxtApp) => {
  await clientInit(nuxtApp as NuxtApp);
});
